"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConceptMapperApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var ConceptMapperApi = /** @class */ (function (_super) {
    __extends(ConceptMapperApi, _super);
    function ConceptMapperApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Convert gene names (including aliases, previous names) into commercial codes
     */
    ConceptMapperApi.prototype.geneNamesToCommercialCodesFromConceptMapperControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.geneNamesToCodesRequestDto === null || requestParameters.geneNamesToCodesRequestDto === undefined) {
                            throw new runtime.RequiredError('geneNamesToCodesRequestDto', 'Required parameter requestParameters.geneNamesToCodesRequestDto was null or undefined when calling geneNamesToCommercialCodesFromConceptMapperController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/concept-mapper/gene-names-to-commercial-codes",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.GeneNamesToCodesRequestDtoToJSON)(requestParameters.geneNamesToCodesRequestDto),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GeneNamesToTestsDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Convert gene names (including aliases, previous names) into commercial codes
     */
    ConceptMapperApi.prototype.geneNamesToCommercialCodesFromConceptMapperController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.geneNamesToCommercialCodesFromConceptMapperControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns information about provided gene names
     */
    ConceptMapperApi.prototype.genesInfoFromConceptMapperControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.geneInfoRequestDto === null || requestParameters.geneInfoRequestDto === undefined) {
                            throw new runtime.RequiredError('geneInfoRequestDto', 'Required parameter requestParameters.geneInfoRequestDto was null or undefined when calling genesInfoFromConceptMapperController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/concept-mapper/gene-info",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.GeneInfoRequestDtoToJSON)(requestParameters.geneInfoRequestDto),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GeneInfoResultsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns information about provided gene names
     */
    ConceptMapperApi.prototype.genesInfoFromConceptMapperController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.genesInfoFromConceptMapperControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets main clinical areas for Invitae
     */
    ConceptMapperApi.prototype.getClinicalAreasFromConceptMapperControllerRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/concept-mapper/clinical-areas",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Gets main clinical areas for Invitae
     */
    ConceptMapperApi.prototype.getClinicalAreasFromConceptMapperController = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getClinicalAreasFromConceptMapperControllerRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get commercial test from partial code
     */
    ConceptMapperApi.prototype.getCommercialTestFromPartialCodeFromConceptMapperControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.code === null || requestParameters.code === undefined) {
                            throw new runtime.RequiredError('code', 'Required parameter requestParameters.code was null or undefined when calling getCommercialTestFromPartialCodeFromConceptMapperController.');
                        }
                        queryParameters = {};
                        if (requestParameters.code !== undefined) {
                            queryParameters['code'] = requestParameters.code;
                        }
                        if (requestParameters.fields !== undefined) {
                            queryParameters['fields'] = requestParameters.fields;
                        }
                        if (requestParameters.availableOnly !== undefined) {
                            queryParameters['availableOnly'] = requestParameters.availableOnly;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/concept-mapper/get-commercial-test-from-partial-code",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CommercialTestDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get commercial test from partial code
     */
    ConceptMapperApi.prototype.getCommercialTestFromPartialCodeFromConceptMapperController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCommercialTestFromPartialCodeFromConceptMapperControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a commercial tests from partial codes
     */
    ConceptMapperApi.prototype.getCommercialTestsFromPartialCodesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.getCommercialTestsFromPartialCodesRequest === null || requestParameters.getCommercialTestsFromPartialCodesRequest === undefined) {
                            throw new runtime.RequiredError('getCommercialTestsFromPartialCodesRequest', 'Required parameter requestParameters.getCommercialTestsFromPartialCodesRequest was null or undefined when calling getCommercialTestsFromPartialCodes.');
                        }
                        queryParameters = {};
                        if (requestParameters.availableOnly !== undefined) {
                            queryParameters['available_only'] = requestParameters.availableOnly;
                        }
                        if (requestParameters.fields !== undefined) {
                            queryParameters['fields'] = requestParameters.fields;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/concept-mapper/commercial-tests-from-partial-codes",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.GetCommercialTestsFromPartialCodesRequestToJSON)(requestParameters.getCommercialTestsFromPartialCodesRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.CommercialTestFromJSON); })];
                }
            });
        });
    };
    /**
     * Get a commercial tests from partial codes
     */
    ConceptMapperApi.prototype.getCommercialTestsFromPartialCodes = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCommercialTestsFromPartialCodesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets main clinical areas for Invitae with additional fields: displayName, testSelectionName, code
     */
    ConceptMapperApi.prototype.getFullClinicalAreasFromConceptMapperControllerRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/concept-mapper/full-clinical-areas",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.RestrictedCategoryDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Gets main clinical areas for Invitae with additional fields: displayName, testSelectionName, code
     */
    ConceptMapperApi.prototype.getFullClinicalAreasFromConceptMapperController = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getFullClinicalAreasFromConceptMapperControllerRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets primary commercial areas for Invitae
     */
    ConceptMapperApi.prototype.getPrimaryCommercialAreasFromConceptMapperControllerRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/concept-mapper/primary-commercial-areas",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Gets primary commercial areas for Invitae
     */
    ConceptMapperApi.prototype.getPrimaryCommercialAreasFromConceptMapperController = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPrimaryCommercialAreasFromConceptMapperControllerRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    ConceptMapperApi.prototype.lookupGeneIdsFromConceptMapperControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.geneIdLookupRequestDto === null || requestParameters.geneIdLookupRequestDto === undefined) {
                            throw new runtime.RequiredError('geneIdLookupRequestDto', 'Required parameter requestParameters.geneIdLookupRequestDto was null or undefined when calling lookupGeneIdsFromConceptMapperController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/concept-mapper/lookup-gene-ids",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.GeneIdLookupRequestDtoToJSON)(requestParameters.geneIdLookupRequestDto),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    ConceptMapperApi.prototype.lookupGeneIdsFromConceptMapperController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.lookupGeneIdsFromConceptMapperControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Fetched available tier one panels for passed concepts
     */
    ConceptMapperApi.prototype.lookupTierOnePanelsFromConceptMapperControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.lookupTierOnePanelsRequestDto === null || requestParameters.lookupTierOnePanelsRequestDto === undefined) {
                            throw new runtime.RequiredError('lookupTierOnePanelsRequestDto', 'Required parameter requestParameters.lookupTierOnePanelsRequestDto was null or undefined when calling lookupTierOnePanelsFromConceptMapperController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/concept-mapper/tier-one-panels",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.LookupTierOnePanelsRequestDtoToJSON)(requestParameters.lookupTierOnePanelsRequestDto),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.TierOnePanelDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Fetched available tier one panels for passed concepts
     */
    ConceptMapperApi.prototype.lookupTierOnePanelsFromConceptMapperController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.lookupTierOnePanelsFromConceptMapperControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Find a rereq set by commercial test codes
     */
    ConceptMapperApi.prototype.postFindRereqFromCommercialTestsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.postLookupCommercialTestsRequest === null || requestParameters.postLookupCommercialTestsRequest === undefined) {
                            throw new runtime.RequiredError('postLookupCommercialTestsRequest', 'Required parameter requestParameters.postLookupCommercialTestsRequest was null or undefined when calling postFindRereqFromCommercialTests.');
                        }
                        queryParameters = {};
                        if (requestParameters.fields !== undefined) {
                            queryParameters['fields'] = requestParameters.fields;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/concept-mapper/rereq-set-picker",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.PostLookupCommercialTestsRequestToJSON)(requestParameters.postLookupCommercialTestsRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RereqSetFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Find a rereq set by commercial test codes
     */
    ConceptMapperApi.prototype.postFindRereqFromCommercialTests = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postFindRereqFromCommercialTestsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Lookup commercial tests by codes
     */
    ConceptMapperApi.prototype.postLookupCommercialTestsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.postLookupCommercialTestsRequest === null || requestParameters.postLookupCommercialTestsRequest === undefined) {
                            throw new runtime.RequiredError('postLookupCommercialTestsRequest', 'Required parameter requestParameters.postLookupCommercialTestsRequest was null or undefined when calling postLookupCommercialTests.');
                        }
                        queryParameters = {};
                        if (requestParameters.fields !== undefined) {
                            queryParameters['fields'] = requestParameters.fields;
                        }
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/concept-mapper/commercial-tests",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.PostLookupCommercialTestsRequestToJSON)(requestParameters.postLookupCommercialTestsRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.CommercialTestFromJSON); })];
                }
            });
        });
    };
    /**
     * Lookup commercial tests by codes
     */
    ConceptMapperApi.prototype.postLookupCommercialTests = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postLookupCommercialTestsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * checks for rna eligibility, returns RNA concepts for given parent codes: ({\"PR20572.40\":[{\"AggregationType\":\"CT_GENE\",\"Code\":\"PR855548.23\",\"Name\":\"TP53\",\"TotalGenesCount\":0}]})
     */
    ConceptMapperApi.prototype.rnaEligibilityConceptsFromConceptMapperControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.rnaEligibleConceptsDto === null || requestParameters.rnaEligibleConceptsDto === undefined) {
                            throw new runtime.RequiredError('rnaEligibleConceptsDto', 'Required parameter requestParameters.rnaEligibleConceptsDto was null or undefined when calling rnaEligibilityConceptsFromConceptMapperController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/concept-mapper/rna-eligibility-concepts",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.RnaEligibleConceptsDtoToJSON)(requestParameters.rnaEligibleConceptsDto),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * checks for rna eligibility, returns RNA concepts for given parent codes: ({\"PR20572.40\":[{\"AggregationType\":\"CT_GENE\",\"Code\":\"PR855548.23\",\"Name\":\"TP53\",\"TotalGenesCount\":0}]})
     */
    ConceptMapperApi.prototype.rnaEligibilityConceptsFromConceptMapperController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rnaEligibilityConceptsFromConceptMapperControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * checks for rna eligibility, returns RNA codes for given parent codes: ({\"PR20572.40\":[\"PR855548.23\"]}
     */
    ConceptMapperApi.prototype.rnaEligibilityFromConceptMapperControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.rnaEligibilityRequestDto === null || requestParameters.rnaEligibilityRequestDto === undefined) {
                            throw new runtime.RequiredError('rnaEligibilityRequestDto', 'Required parameter requestParameters.rnaEligibilityRequestDto was null or undefined when calling rnaEligibilityFromConceptMapperController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/concept-mapper/rna-eligibility",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.RnaEligibilityRequestDtoToJSON)(requestParameters.rnaEligibilityRequestDto),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * checks for rna eligibility, returns RNA codes for given parent codes: ({\"PR20572.40\":[\"PR855548.23\"]}
     */
    ConceptMapperApi.prototype.rnaEligibilityFromConceptMapperController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rnaEligibilityFromConceptMapperControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Validates cart
     */
    ConceptMapperApi.prototype.validateCartRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.data === null || requestParameters.data === undefined) {
                            throw new runtime.RequiredError('data', 'Required parameter requestParameters.data was null or undefined when calling validateCart.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/concept-mapper/validate-cart",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.ValidateCartRequestToJSON)(requestParameters.data),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ValidateCart200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Validates cart
     */
    ConceptMapperApi.prototype.validateCart = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateCartRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ConceptMapperApi;
}(runtime.BaseAPI));
exports.ConceptMapperApi = ConceptMapperApi;
